import React, { useState, useEffect } from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";
import { shopifyFetch } from '../shopify/client';
import { GET_PRODUCTS } from '../shopify/queries';
import { useDispatch } from 'react-redux';
import { addToCart } from '../shopify/cartActions';

const Products = (props) => {
    const type = props.match.params.type;
    const dispatch = useDispatch();

    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        setLoading(true);
        setError(null);

        shopifyFetch(GET_PRODUCTS, { type })
            .then((res) => {
                const items = res.data.products.edges.map((edge) => edge.node);
                setProducts(items);
            })
            .catch((err) => setError(err.message))
            .finally(() => setLoading(false));
    }, [type]);

    return (
        <div>
            <Header />

            <div id="content-header">
                <div className="container">
                    <h1 className="text-uppercase">{type}</h1>
                    <p>Train Harder. Move better. Live stronger. Explore our collection of
                        high performance t-shirts designed for ultimate comfort, breathability
                        and durability.</p>
                </div>
            </div>

            <div className="container mt-5 mb-5" id="product">
                <h5 id="tx-title">SHOP BY COLLECTION</h5>

                {loading && <p>Loading products...</p>}
                {error && <p className="text-danger">Failed to load products: {error}</p>}

                <div className="row">
                    {!loading && !error && products.map((product) => {
                        const image = product.images.edges[0]?.node;
                        const price = parseFloat(product.priceRange.minVariantPrice.amount).toFixed(2);
                        const currency = product.priceRange.minVariantPrice.currencyCode;

                        return (
                            <div
                                key={product.id}
                                className="col-12 col-md-3"
                                onClick={() => props.history.push(`/product-detail/${product.handle}`)}
                                style={{ cursor: 'pointer' }}
                            >
                                <img
                                    className="img-fluid mb-2"
                                    src={image?.url || 'assets/images/sample-1.jpg'}
                                    alt={image?.altText || product.title}
                                />
                                <h4>{product.title}</h4>
                                <p>{currency} {price}</p>
                                <button
                                    className="btn btn-primary btn-cart btn-block"
                                    onClick={(e) => {
                                        e.stopPropagation(); // prevent card click firing too
                                        dispatch(addToCart(product.variants.edges[0]?.node.id));
                                    }}
                                >
                                    ADD TO CART
                                </button>
                            </div>
                        );
                    })}

                    {!loading && !error && products.length === 0 && (
                        <p className="ml-3">No products found in <strong>{type}</strong>.</p>
                    )}
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Products;
